enum PdfFileEnum {
  KOR = "KOR",
  ENG = "ENG",
}

export enum PdfFileNameEnum {
  KOR = "(KOR)_2024_Company_Brochure",
  ENG = "(ENG)_2024_Company_Brochure",
}

export interface CompanyProfileType {
  label: PdfFileEnum;
  fileName: PdfFileNameEnum;
}

export const handlePdfDownload = (fileName: PdfFileNameEnum) => {
  const pdfUrl = process.env.PUBLIC_URL + `/pdfs/${fileName}.pdf`;
  const link = document.createElement("a");
  link.href = pdfUrl;
  link.download = `${fileName}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downLoadCompanyProfileData: CompanyProfileType[] = [
  {
    label: PdfFileEnum.KOR,
    fileName: PdfFileNameEnum.KOR,
  },
  {
    label: PdfFileEnum.ENG,
    fileName: PdfFileNameEnum.KOR,
  },
];
